import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="pointer-events-none select-none font-heading text-9xl font-black text-background-200 md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10 -mt-6">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          This page has not been generated
        </h2>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-left-line"></i>
          </span>
          Back to Home
        </Link>
      </div>
    </div>
  );
}